import { selectRowByRowIndex } from '@client-shared/ui-agGrid';

import {
  REMOVE_SCENARIO,
  REMOVE_SCENARIO_SUCCESS,
  REMOVE_SCENARIO_FAILURE,

  UPDATE_SCENARIO_LIST_COLUMN_STATE,
} from './types';

import {
  removeScenario as removeScenarioApi,
} from '../../shared/api';

import getModalActions from '../../../shared/modals/getModalActions';
import { ModalNames } from '../constants';
import { fetchingError } from '../../../shared/store/actions';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';

import { fetchScenarios } from '../../shared/store/actions';

export const {
  showAction: showRemoveScenarioModal,
  hideAction: hideRemoveScenarioModal,
} = getModalActions(ModalNames.Delete);

export const removeScenario = (scenario, { rowIndex }) => async dispatch => {
  try {
    dispatch({ type: REMOVE_SCENARIO });

    await removeScenarioApi(scenario);
    await dispatch(fetchScenarios());

    dispatch(selectRowByRowIndex(rowIndex ? rowIndex - 1 : 0));
    dispatch({ type: REMOVE_SCENARIO_SUCCESS });
    dispatch(hideRemoveScenarioModal());
    dispatch(successNotification('Scenario removed successfully'));
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({ type: REMOVE_SCENARIO_FAILURE });
    }
    throw error;
  }
};

export const updateColumnState = columnState => dispatch => {
  dispatch({ type: UPDATE_SCENARIO_LIST_COLUMN_STATE, newColumnState: columnState });
};
